/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Flickity from "flickity";

/*------------------------------------*\
    Carousel
\*------------------------------------*/
class CardCarousel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.carouselElem = self.elem.querySelector('[data-carousel]');
        self.prevButton = self.elem.querySelector('[data-carousel-prev]');
        self.nextButton = self.elem.querySelector('[data-carousel-next]');
    }

    init() {
        let self = this;

        self.getCarousel();
    }

    getCarousel() {
        let self = this;

        const flkty = new Flickity(self.carouselElem, {
            wrapAround: true,
            prevNextButtons: false,
        });

        self.prevButton.addEventListener('click', function() {
            flkty.previous();
        });

        self.nextButton.addEventListener('click', function() {
            flkty.next();
        });
    }
}

export default CardCarousel;
